import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';
import { translate } from 'utils/translate';
import usePartnerLogos from './hooks/usePartnerLogos';

// Rendered inside the expanded cash card: the stores where that provider's reference can be paid.
const PartnerStoresGrid = ({ provider, title, className = '' }) => {
  const literals = useLiterals('paymentCheckout');
  const logos = usePartnerLogos(provider);

  if (!logos.length) return null;

  return (
    <section className={className} data-testid='partner-stores'>
      <h4 className='mb-3 text-[13px] font-semibold uppercase tracking-wide text-primary-700'>{title}</h4>
      <ul className='m-0 grid list-none grid-cols-3 gap-3 p-0'>
        {logos.map(({ url, name }) => (
          <li key={url} className='flex h-16 items-center justify-center rounded-xl bg-white p-2 shadow-card'>
            <img
              src={url}
              alt={translate(literals.storeLogoAlt, { name })}
              loading='lazy'
              className='h-full w-full object-contain'
            />
          </li>
        ))}
      </ul>
    </section>
  );
};

PartnerStoresGrid.propTypes = {
  provider: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default PartnerStoresGrid;
